import { LLM_FAMILIES } from './llmFamilies';

function normalizeValue(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

function valuesEqual(a, b) {
  return normalizeValue(a) === normalizeValue(b);
}

export const HUGGINGFACE_MODEL_NAME_REGEX =
  /^(\b[\w\-.]+\b\/)?\b[\w\-.]{1,96}\b$/;

export function isValidLlmName(value) {
  if (!value) {
    return false;
  }
  return HUGGINGFACE_MODEL_NAME_REGEX.test(value);
}

export function transformCheckpoint(checkpoint) {
  if (!checkpoint) {
    return { id: '', as: '', public: false, name: '' };
  }
  const name = checkpoint.name || checkpoint.as || '';
  return {
    id: checkpoint.checkpoint_uuid || checkpoint.id || '',
    as: name,
    public: checkpoint.public || false,
    name,
  };
}

/**
 * Returns LLM form values with advanced override fields cleared when they
 * match the defaults from the model configuration (type + family + size).
 */
export function stripDefaultLlmOverrides(llm, llm_configs) {
  if (!llm?.type || !llm?.family) {
    return llm ? { ...llm } : {};
  }

  const is_custom = llm.family === LLM_FAMILIES.CUSTOM;
  if (!is_custom && !llm.size) {
    return { ...llm };
  }

  const family_config = llm_configs?.[llm.type]?.[llm.family];
  if (!family_config) {
    return { ...llm };
  }

  const size_config = is_custom
    ? undefined
    : family_config.sizes?.[llm.size];
  const result = {
    type: llm.type,
    family: llm.family,
  };
  if (!is_custom) {
    result.size = llm.size;
  }

  if (
    llm.reasoning_parser &&
    !valuesEqual(llm.reasoning_parser, family_config.reasoning_parser)
  ) {
    result.reasoning_parser = llm.reasoning_parser;
  }

  if (
    llm.tool_parser &&
    !valuesEqual(llm.tool_parser, family_config.tool_parser)
  ) {
    result.tool_parser = llm.tool_parser;
  }

  if (
    llm.additional_kwargs &&
    !valuesEqual(llm.additional_kwargs, family_config.additional_kwargs)
  ) {
    result.additional_kwargs = llm.additional_kwargs;
  }

  if (llm.name) {
    const config_name = size_config?.name;
    if (is_custom || !config_name || !valuesEqual(llm.name, config_name)) {
      result.name = llm.name;
    }
  }

  if (is_custom && llm.moe) {
    result.moe = llm.moe;
  }

  if (is_custom && llm.quantization) {
    result.quantization = llm.quantization;
  }

  if (
    llm.concurrent_requests !== undefined &&
    llm.concurrent_requests !== null &&
    llm.concurrent_requests !== ''
  ) {
    result.concurrent_requests = llm.concurrent_requests;
  }

  return result;
}
